module.exports = __webpack_public_path__ + "img/logo.1b319e10.png";